import { apiCall, ApiConfig } from '../../../config/api'
import {
  Supplier,
  ICreateSupplier
} from '../../../interfaces/Supplier/Supplier'
import { Filter } from '../../../components/_WMS/FilterComponent/types'
import { GenericOrderBy } from '../../../components/_EOS/Table/types'

// Mapper de Supplier a ICreateSupplier
export const mapSupplierToCreateSupplier = (
  supplier: Supplier
): ICreateSupplier => {
  return {
    supplierId: supplier.supplierId,
    rutDniSupplier: supplier.rutDniSupplier,
    supplierName: supplier.supplierName,
    minDaysInBound: supplier.minDaysInBound,
    active: supplier.active,
    warehousesId: supplier.warehouses?.map((w) => w.id) || [],
    supplierOrigin: supplier.supplierOrigin,
    productOriginId: supplier.productOriginId
  }
}

export const getSuppliers = (
  filters: Filter[],
  page: number,
  pageSize: number,
  orderBy?: GenericOrderBy<Supplier>
) => {
  const queryParams = new URLSearchParams()
  queryParams.append('pageIndex', page.toString())
  queryParams.append('pageSize', pageSize.toString())

  filters.forEach((filter) => {
    queryParams.append(filter.key, filter.value)
  })

  // Agregar parámetros de ordenamiento
  if (orderBy) {
    const sorters = {
      datafield: orderBy.field.toString(),
      sortOrder: orderBy.direction
    }
    queryParams.append('sorters', JSON.stringify(sorters))
  }

  return apiCall('GET', `${ApiConfig.SupplierApi}?${queryParams.toString()}`)
}

export const createSupplier = (data: Supplier) => {
  const createData = mapSupplierToCreateSupplier(data)
  return apiCall('POST', ApiConfig.SupplierApi, createData)
}

export const updateSupplier = (id: number, data: Supplier) => {
  const updateData = mapSupplierToCreateSupplier(data)
  return apiCall(
    'PUT',
    `${ApiConfig.SupplierApi}/${id}/${data.supplierOrigin[0].id}`,
    updateData
  )
}

export const deleteSupplier = (id: number) => {
  return apiCall('DELETE', `${ApiConfig.SupplierApi}/${id}`)
}
